import { commonProperties } from '../constants';

export const header = {
  type: 'dw_header',
  name: 'Header',
  icon: 'fas fa-bars',
  settings: {},
  formSchema: {
    properties: { ...commonProperties },
    required: []
  },
  allowChildren: false,
  color: 'blue',
  group: 'ui'
};
